// create a hook that will determine if the prescription is upsell, initial or refill and add it to visit metadata
/// use orders, pathname, and prescriptions(if needed)

import { useGetOrdersQuery } from "src/api/services/ordersApi";
import { OrderTypeEnum } from "src/api/types";

export function useDeterminePrescriptionType(
  product_id: number | undefined,
  patient_id: number,
) {
  const { data: orders } = useGetOrdersQuery({
    from: 0,
    to: 100,
    product_id,
    patient_id: String(patient_id),
  });

  if (orders == null || orders.data.length === 0) {
    return OrderTypeEnum.Upsell;
  }

  return OrderTypeEnum.Refill;
}
